// BEE-16: Landing page scaffold
// Each section is a stub -- BEE-17 through BEE-21 fill them in with real content.
import TopNav from '@/components/landing/TopNav'
import Hero from '@/components/landing/Hero'
import HowItWorks from '@/components/landing/HowItWorks'
import Features from '@/components/landing/Features'
import Testimonial from '@/components/landing/Testimonial'
import Pricing from '@/components/landing/Pricing'
import BottomCTA from '@/components/landing/BottomCTA'
import Footer from '@/components/landing/Footer'

export default function Landing() {
  return (
    <div className="bg-paper min-h-screen font-sans text-ink">
      <TopNav />
      <main>
        <Hero />
        <HowItWorks />
        <Features />
        <Testimonial />
        <Pricing />
        <BottomCTA />
      </main>
      <Footer />
    </div>
  )
}
